"use client";
import { usePathname } from 'next/navigation';
import SiteFooter from './site-footer';

// Route prefixes considered protected (no marketing footer)
const PROTECTED_PREFIXES = [
  '/preceptors',
  '/preceptor',
  '/student',
  '/staff',
  '/admin',
  '/np',
  '/ap',
  '/img',
  '/unauthorized',
  '/docuseal',
];

export default function ProtectedAwareFooter() {
  const pathname = usePathname();
  if (!pathname) return null;

  const hide = PROTECTED_PREFIXES.some(prefix => pathname.startsWith(prefix));
  if (hide) return null;
  return <SiteFooter />;
}
